import React from 'react';
import { Toaster } from 'sonner';
import { RestoreDeletedCases } from './components/RestoreDeletedCases';
export function App() {
  return <div className="min-h-screen bg-slate-100 flex items-start justify-center p-4 md:p-8 antialiased" data-id="element-0">
      <RestoreDeletedCases data-id="element-1" />
      <Toaster position="bottom-right" toastOptions={{
      style: {
        background: 'white',
        border: '1px solid #e2e8f0',
        color: '#0f172a',
        boxShadow: '0 4px 12px rgb(0 0 0 / 0.08)',
        fontSize: '14px'
      },
      className: 'rounded-lg'
    }} data-id="element-2" />
    </div>;
}